import {createAsyncThunk} from "@reduxjs/toolkit";
import {fetchFeaturedContent} from "../../api/home/homeApi";
import {setValue} from "./reducers";
import {RootState} from "../../store";

export const getFeaturedContent = createAsyncThunk<void, void, { state: RootState }>('player/updateStatus',
    async (_, {dispatch, getState}) => {
        const {featuredContent, isLoading} = getState().home;
        if (!featuredContent.length && !isLoading) {
            dispatch(setValue({key: 'isLoading', value: true}));
            const data = await fetchFeaturedContent();
            dispatch(setValue({key: 'featuredContent', value: data}));
            dispatch(setValue({key: 'isLoading', value: false}));
        }
    }
);

export type HomeActions = ReturnType<
    typeof getFeaturedContent
>;
